import React from "react";

import {
  Redirect
} from "react-router-dom";
import { getAuth } from "../../../utils/authStorage";

export default function ProtectedRouteV2({

  children

}) {

  const auth =
    getAuth();

  if (
    !auth?.accessToken
  ) {

    return (
      <Redirect
        to="/"
      />
    );
  }

  return children;
}